import React, { FC, useEffect } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { Form, Spin } from 'antd';
import { MainReducerState } from '../../store/reducers';
import { connect } from 'react-redux';
import { FormProps } from 'antd/lib/form';
import { RouteProps } from 'react-router-dom';
import { DrawerProps } from 'antd/lib/drawer';
import { ButtonProps } from 'antd/lib/button';

import {
    OrganizationsState,
    details as organizationDetails,
    update as organizationUpdate,
    create as organizationCreate,
} from '../../store/actions/organizations';
import OrganizationFilterSelect from './OrganizationFilterSelect';

const requiredRule = { required: true, message: 'Ce champ est obligatoire' };

interface OrganizationModalProps extends RouteProps {
    isVisible: boolean;
    onClose: () => void;
    onSuccess?: (payload: any) => void;

    organizations: OrganizationsState;
    getDetails: typeof organizationDetails.trigger;
    detailsReset: typeof organizationDetails.reset;
    update: typeof organizationUpdate.trigger;
    updateReset: typeof organizationUpdate.reset;
    create: typeof organizationCreate.trigger;
    createReset: typeof organizationCreate.reset;
}

const OrganizationModal: FC<OrganizationModalProps> = ({
    isVisible,
    onClose,
    onSuccess,

    organizations,
}) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (isVisible) {
            form.resetFields();
        }
    }, [isVisible, form]);

    const onFormFinish: FormProps['onFinish'] = (values) => {
        form.validateFields().then(() => {
            if (onSuccess) { onSuccess(values); }
        });
    };

    const onDrawerClose: DrawerProps['onClose'] & ButtonProps['onClick'] = () => {
        onClose();
        form.resetFields();
    };

    return (
        <Modal
            className="select-modal"
            title={'Dupliquer chez un client'}
            width={500}
            onCancel={onDrawerClose}
            centered
            visible={isVisible}
            destroyOnClose={true}
            okText={'Valider'}
            okButtonProps={{
                type: 'primary',
                shape: 'round',
            }}
            cancelText={'Annuler'}
            cancelButtonProps={{
                shape: 'round',
            }}
            onOk={form.submit}
        >
            <Spin spinning={organizations.details.loading}>
                <Form
                    form={form}
                    onFinish={onFormFinish}
                    layout="vertical"
                    hideRequiredMark
                >
                    <Form.Item
                        name="organization"
                        rules={[requiredRule]}
                    >
                        <OrganizationFilterSelect
                            size="large"
                        />
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );

};

const mapStateToProps = (state: MainReducerState) => ({
    organizations: state.organizations,
});

export default connect(
    mapStateToProps,
    {
        getDetails: organizationDetails.trigger,
        detailsReset: organizationDetails.reset,
        create: organizationCreate.trigger,
        createReset: organizationCreate.reset,
        update: organizationUpdate.trigger,
        updateReset: organizationUpdate.reset,
    },
)(OrganizationModal);
